import { ZENDESK_JWT_ENDPOINT } from '@/constants/endpoints.ts';
import http from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types.ts';

/**
 * Exchanges a depop bearer token for a ZD jwt.
 */
export function getZendeskJwt(): Promise<
  AxiosCompatibleResponse<{ jwt: string }>
> {
  return http.get(ZENDESK_JWT_ENDPOINT, { withAuth: true });
}
